import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import logo from "../assets/flaskLogo.png";
import Input from "./common/input";
import Select from "./common/select";
import auth from "../services/authService";
import Checkbox from "./common/checkbox";

class Login extends Component {
  state = {
    sites: [
      { id: "BA", name: "Bardney" },
      { id: "BU", name: "Bury" },
      { id: "CA", name: "Cantley" },
      { id: "NE", name: "Newark" },
      { id: "WI", name: "Wissington" },
      { id: "CO", name: "Peterborough" },
    ],
    user: {
      username: "",
      password: "",
      site: "",
    },
    rememberMe: false,
    errors: {},
    loading: false,
  };

  componentDidMount() {
    document.title = "FTR - Login";

    try {
      const site = localStorage.getItem("ftr-preferred-site");
      const username = localStorage.getItem("ftr-preferred-user");
      let rememberMe = localStorage.getItem("ftr-remember-me");

      rememberMe = rememberMe === "true" ? true : false;

      if (rememberMe) {
        const user = { ...this.state.user };
        if (site) user.site = site;
        if (username) user.username = username;

        this.setState({ user, rememberMe });
      }
      else {
        this.setState({ rememberMe });
      }
    }
    catch (ex) {}
  }

  componentWillUnmount() {
    document.title = "FTR";
  }

  handleChange = ({ currentTarget: input }) => {
    const user = { ...this.state.user };
    user[input.name] = input.value;
    this.setState({ user });
  };

  handleLogin = async (e) => {
    e.preventDefault();
    const { user, rememberMe } = this.state;
    this.setState({ loading: true });
    
    try {
      if (rememberMe) {
        localStorage.setItem("ftr-preferred-user", user.username.toUpperCase());
        localStorage.setItem("ftr-preferred-site", user.site);
      }
      else {
        localStorage.removeItem("ftr-preferred-user");
        localStorage.removeItem("ftr-preferred-site");
      }

      await auth.login(user.username, user.password, user.site);
      return (window.location = "/");
    } catch (ex) {
      this.setState({ loading: false });
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.site = ex.response.data;
        this.setState({ errors });
        if (user.site === "") return toast.error("invalid site");
        toast.error(ex.response.data);
      }
    }
  };

  handleRememberMe = ({ currentTarget: input }) => {
    localStorage.setItem("ftr-remember-me", !this.state.rememberMe);
    this.setState({ rememberMe: !this.state.rememberMe });
  };

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/" />;
    const { loading } = this.state;

    return (
      <div className="container-fluid">
        <div className="col-lg-3 col-md-6 col-xs-12 mx-auto mt-5">
          <div className="mx-auto" style={{ width: 275 }}>
            <img className="img-fluid" src={logo} alt="British Sugar Logo" />
          </div>
          <form onSubmit={this.handleLogin}>
            <h1 className="text-center">Factory Technical Reporting</h1>
            <Input
              name="username"
              label="Username"
              type="text"
              placeholder=""
              value={this.state.user.username}
              onChange={this.handleChange}
              error={this.state.errors.username}
            />
            <Input
              name="password"
              label="Password"
              type="Password"
              placeholder=""
              value={this.state.user.password}
              onChange={this.handleChange}
              error={this.state.errors.password}
            />
            <Select
              name="site"
              label="Site"
              placeholder="Select Site..."
              value={this.state.user.site}
              options={this.state.sites}
              onChange={this.handleChange}
              error={this.state.errors.site}
            />
            <Checkbox
              name="rememberMe"
              label="Remember Me"
              checked={this.state.rememberMe}
              onClick={this.handleRememberMe}
            />
            <button
              type="submit"
              className="btn btn-block btn-success mt-4"
              disabled={loading}
            >
              {loading ? (
                <div
                  className="spinner-border spinner-border-sm text-white"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Sign In"
              )}
            </button>
          </form>
          <Link to="/register">
            <button className="btn btn-block btn-light mt-2">Register</button>
          </Link>
          <p className="mt-4 text-center text-muted">
            Forgot Password? <Link to="/Reset">Reset</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Login;
